import React from "react";
import { useProviderInfoPageContext } from "../Context";
import { LoadingIndicator } from "../LoadingIndicator";
import { useCategoryMetaContext } from "../Context/CategoryMetaContext";
import { CategoryDisplay } from "../Container";

// import { TabDemo, GraphTableInfoToggleDemo, PlainPanelDemo, SectionDemo } from "../Container";
// {
//      <TabDemo />
//      <GraphTableInfoToggleDemo />
//      <PlainPanelDemo />
//      <SectionDemo />
// }

export const ProviderReportWithContext = () => {
    const { loading } = useProviderInfoPageContext();

    const { categoryLoading, roots } = useCategoryMetaContext();
    // console.log("loading/categoryLoading", loading, categoryLoading);
    return (
        <div className="col-12">
            {(loading || categoryLoading) && <LoadingIndicator />}

            <CategoryDisplay categories={roots} />
        </div>
    );
};
